// SMS Configuration
export const SMS_SENDER_PHONE = '+1(440) 581.8253';